import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'

interface Props {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuExpenses: FC<Props> = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}) => {
  const intl = useIntl()
  return (
    <MenuList disablePadding={true} onClick={toggleDrawerOnMobile}>
      <MenuItem
        key="expenses"
        data-test="hr-bots_sidebar_menuitem"
        component={ButtonLink}
        href="/hr-bot/expenses?page=1"
        selected={pathname.includes('hr-bot/expenses')}
        className={nested}
      >
        <ListItemIcon data-test="hr-bot_sidemenu_icon">
          <AccountBalanceWalletIcon />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({
            id: 'expenses.sidebar',
          })}
        />
      </MenuItem>
    </MenuList>
  )
}
